export default {
	'userCancel': '用户取消',
	'addrLp': 'LP合约地址',
	'bscInLbb': '跨链',
	'goSwap': 'CSwap交易',
	'sumLbb': '累计 {0} OC',
	'lookLbb': '查看合约',
	'addrLbb': 'OC合约地址',
	'addrLock': '锁仓合约地址',
	'lockedBalance': '我的锁仓余额',
	'ocLockTitle': 'OC 锁仓',
	'ocLockDeposit': '存款',
	'ocLockActive': '状态',
	'ocLockReleased': '已释放',
	'ocLockClaim': '提现',
	'lockTotal': '总额',
	'lockDays': '剩余天数/锁仓天数',
	'lockClaimable': '可提取',
	'lockClaimed': '已提取',
	'addrDead': '黑洞地址',
	'addrMarket': '营销地址',
	'ratioTotal': '卖出总滑点：10%',
	'ratioLp': 'a. 流动性系数：5%',
	'ratioDead': 'b. 销毁系数：3%',
	'ratioInv': 'c. 邀请系数：1%',
	'ratioMarket': 'd. 营销系数：1%',
	'contractDesc': '逻辑全链实现',
	'contract': '合约',
	'inviteTotal': '全网邀请奖励： {0} OC',
	'inviteMy': '我的邀请奖励： {0} OC',
	'lpTotal': '全网流动性奖励： {0} OC',
	'lpMy': '我的流动性奖励： {0} OC',
	'lpDesc': '我的/全网流动性: {0} / {1} LCC',
	'lpAdd': '添加流动性',
	'lp': '流动性',
	'invSell': '最高 1% 邀请奖励',
	'lpSell': '持有流动性加权奖励每笔卖出的 5%',
	'myInvites': '我的邀请',
	'effective': '有效',
	'ineffective': '无效',
	'myInviter': '我的推荐人',
	'invite': '邀请',
	'inviteNotice1': '给对方发送 0.1 OC',
	'inviteNotice2': '待对方确认后，即邀请成功',
	'inviteBind': '请绑定您的推荐人',
	'chainConfirm': '上链中···',
	'{0} Operate Fast': '{0}操作太频繁，请{1}秒后继续',
	'English': 'English',
	'Chinese': '中文',
	'Conrim': '确认',
	'Osnft Detail': '查看详情',
	'{0} Not Enogugh': '您的 {0} 不足',
	'Operate Success': '操作成功',
	'zlang143': '复制成功',
	'Cht': '繁體中文',
	'YueNan': 'Việt Nam',
	'YinNi': 'Bahasa Indonesia',
	'RiWen': ' にほんご',
	'HanWen': '한국어',
	'TaiWen': 'ไทย',
	'ALaBoWen': ' العربية ',
	'Balance Query': '余额查询',
	'Input Address': '请输入地址',
	'Query': '查询',
	'Query Result': '查询结果',
	'No Deposits': '暂无锁仓记录',
	'Refresh': '刷新',
	'No Records': '暂无记录',
	'eventLogs': '事件日志',
	'eventCount': '记录数',
	'eventTotal': '金额汇总',
	'eventAll': '全部',
	'eventInviteFeature': '邀请功能',
	'eventRewardFeature': '奖励功能',
	'eventBonusFeature': '挖矿功能',
	'eventLockFeature': '锁仓功能',
	'eventLock': '锁仓',
	'eventRelease': '释放',
	'eventClaim': '提取',
	'eventBonus': '分红',
	'eventInvite': '邀请',
	'eventTransfer': '转入',
	'eventOcLocked': 'OC锁仓',
	'eventOcStaticRelease': '静态释放',
	'eventOcDynamicRelease': '动态释放',
	'eventOcClaimed': '锁仓提取',
	'eventBonusTriggered': '动能分配',
	'eventBonusReceived': '动能到账',
	'eventInviteRequested': '请求邀请',
	'eventDirectReward': '直推奖励',
	'eventLiquidityReward': '流动性奖励',
	'eventSlowQueryProgress': '查询较慢，已查询到 {0}/{1} 区块',
	'eventTenLevelBonus': '十层挖矿',
	'eventTenLevelBonusReceived': '十层挖矿到账',
	'eventReferralConfirmed': '邀请确认',
	'eventEffectiveInvite': '有效邀请',
	'eventEffectiveLp': '有效账户',
	'eventTransferIn': '转入',
	'Please Input Address': '请输入有效的地址',
	'Lp Bonus Balance': '分红合约 OC 余额',
	'Lp Bonus Distributed': '已分配分红',
	'addrBonus': '分红合约地址',
	'fund5': '基金会',
	'ecoBurn5': '生态销毁',
	'genesis5': '创世团队',
	'tech3': '技术服务',
	'market10': '市值管理',
	'coFound30': '联创团队',
	'lpDepth10': '我的动态矿池奖励：{0} OC',
	'themeNeon': '霓虹蓝紫',
	'themeIce': '冰蓝电路',
	'themeViolet': '紫金夜色',
	'themeAurora': '极光薄荷',
	'themeEmber': '焰火暗夜',
	'themeMono': '深空冷灰',
	'delLpTimeScale': '2月內撤流动性最多 3 倍暴击',
}
